import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    interfaces: {}
};
const networkSlice = createSlice({
    name: "network",
    initialState,
    reducers: {
        setLatestRates (state, action) {
            const { interfaceName, rxRate, txRate } = action.payload;
            if (!state.interfaces[interfaceName]) {
                state.interfaces[interfaceName] = {
                    rxData: [],
                    txData: []
                };
            }
            state.interfaces[interfaceName].rx_rate_mbps = rxRate;
            state.interfaces[interfaceName].tx_rate_mbps = txRate;
        },
        setNetworkHistoricalData (state, action) {
            const { interfaceName, key, data } = action.payload;
            if (!state.interfaces[interfaceName]) {
                state.interfaces[interfaceName] = {
                    rxData: [],
                    txData: []
                };
            }
            state.interfaces[interfaceName][key] = data;
        },
        addNetworkUtilizationDataPoint (state, action) {
            const { interfaceName } = action.payload;
            if (!state.interfaces[interfaceName]) {
                state.interfaces[interfaceName] = {
                    rxData: [],
                    txData: []
                };
            }
            const iface = state.interfaces[interfaceName];
            const now = Date.now();
            const oldestPoint = now - 60 * 60 * 1000;
            const cutoff = new Date(oldestPoint).getTime();
            const updateData = (arr, val)=>{
                const filtered = arr.filter((d)=>d.x >= cutoff);
                if (val != null) {
                    return [
                        ...filtered,
                        {
                            x: now,
                            y: val
                        }
                    ];
                } else {
                    return filtered;
                }
            };
            iface.rxData = updateData(iface.rxData, iface.rx_rate_mbps);
            iface.txData = updateData(iface.txData, iface.tx_rate_mbps);
        }
    }
});
export const { setLatestRates, setNetworkHistoricalData, addNetworkUtilizationDataPoint } = networkSlice.actions;
export default networkSlice.reducer;
